import { render, staticRenderFns } from "./ElementDropdown.vue?vue&type=template&id=2236454d&scoped=true&"
import script from "./ElementDropdown.vue?vue&type=script&lang=js&"
export * from "./ElementDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ElementDropdown.vue?vue&type=style&index=0&id=2236454d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2236454d",
  null
  
)

export default component.exports